// 'registration' 영역 문구. 키는 ko / en 에 똑같이 둔다.
const registration = {
  ko: {
    steps: {
      tournament: '대회 선택',
      affiliation: '소속 정보',
      category: '참가 구분',
    },
    stepperAria: '신청 진행 단계',
    intro: {
      title: '대회 참가신청',
      desc: '아래 단계에 따라 정보를 입력하고 대회 참가를 신청해 주세요.',
    },
    step1: {
      titleLine1: '참가하실 대회를',
      titleLine2: '선택해 주세요',
      desc: '신청하실 대회를 하나 선택해 주세요. 선택한 대회의 종목별 세부 기준에 따라 대진표가 작성됩니다.',
      lockedDesc: '선택하신 대회입니다. 변경하려면 처음부터 다시 신청해 주세요.',
      empty: '등록된 대회가 없습니다.',
      loadError: '대회 목록을 불러오지 못했습니다.',
    },
    step2: {
      titleLine1: '소속 정보를',
      titleLine2: '입력해 주세요',
      desc: '소속 협회 / 도장 / 본인의 정보를 정확히 기재해 주세요.',
      lockedDesc: '입력하신 소속 정보입니다. 변경하려면 처음부터 다시 신청해 주세요.',
    },
    step3: {
      titleLine1: '참가 구분을',
      titleLine2: '입력해 주세요',
      desc: '대진표 편성을 위해 생년월일, 성별, 학년, 신장 정보가 필요합니다.',
    },
    summary: {
      tournamentTitle: '선택한 대회',
      affiliationTitle: '입력한 소속 정보',
      tournamentName: '대회명',
      location: '장소',
      eventDate: '개최일',
      affiliation: '소속 협회',
      dojo: '도장명',
      coachName: '지도자명',
      name: '이름',
      phone: '참가자 연락처',
      guardianPhone: '보호자 연락처',
    },
    fields: {
      affiliation: '소속 협회 (학교명)',
      dojo: '도장명 (팀명)',
      coachName: '지도자명',
      name: '이름',
      phone: '참가자 연락처',
      guardianPhone: '보호자 연락처',
      birthdate: '생년월일',
      gender: '성별',
      grade: '학년',
      height: '신장 (cm)',
    },
    placeholders: {
      affiliation: '예: 경기도 태권도 협회',
      dojo: '예: 대화 백호 태권도',
      coachName: '예: 김태권',
      name: '예: 하준수',
      height: '예: 151',
    },
    gender: {
      maleOption: '남자 / MALE',
      femaleOption: '여자 / FEMALE',
      maleShort: '남',
      femaleShort: '여',
    },
    buttons: {
      next: '다음 단계 →',
      prev: '← 이전',
      submit: '신청 완료 ✓',
      submitting: '접수 중...',
      reset: '다시 신청하기',
    },
    alerts: {
      selectTournament: '참가하실 대회를 선택해 주세요.',
      requiredAffiliation: '소속, 도장명, 지도자명, 이름은 필수 입력 항목입니다.',
      requiredPhones: '참가자 및 보호자 연락처를 모두 입력해 주세요.',
      selectGender: '성별을 선택해 주세요.',
      selectGrade: '학년을 선택해 주세요.',
      agreePrivacy: '개인정보 수집·이용에 동의해 주세요.',
      submitError: '참가신청 접수에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    },
    complete: {
      titleLine1: '대회 신청이',
      titleLine2: '완료되었습니다',
      subtitleLine1: '참가신청이 정상적으로 접수되었습니다.',
      subtitleLine2: '대진표는 추후 협회 공식 채널을 통해 안내됩니다.',
    },
    addModal: {
      title: '참가자 추가',
      submit: '참가자 추가',
      submitting: '추가 중...',
      error: '참가자 추가에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    },
    privacy: {
      label: '개인정보 수집·이용 동의',
      termsAria: '개인정보 수집·이용 약관',
    },
    grade: {
      placeholder: '학년을 선택해 주세요',
      school: '{n}학년',
      university: '대학교 {n}학년',
      adult: '성인',
    },
    validation: {
      phoneLabel: '연락처',
      phoneRequired: '{label}를 입력해 주세요.',
      phoneInvalid: '{label} 형식이 올바르지 않습니다. 예: 010-1234-5678',
      birthRequired: '생년월일을 입력해 주세요.',
      birthFormat:
        '생년월일 형식이 올바르지 않습니다. YYYY-MM-DD 형식으로 입력해 주세요. (예: 2010-03-03)',
      birthYearRange:
        '생년월일 형식이 올바르지 않습니다. 연도는 {min}년~{max}년 사이로 입력해 주세요.',
      birthMonthDay: '생년월일 형식이 올바르지 않습니다. 월·일을 확인해 주세요.',
      birthNotExist: '생년월일 형식이 올바르지 않습니다. 존재하지 않는 날짜입니다.',
      birthFuture: '생년월일 형식이 올바르지 않습니다. 오늘 이후 날짜는 입력할 수 없습니다.',
      heightRequired: '신장을 입력해 주세요.',
      heightNumber: '신장은 숫자로 입력해 주세요.',
      heightMax: '신장은 {max}cm 이하로 입력해 주세요.',
      heightMin: '신장은 {min}cm 이상으로 입력해 주세요.',
    },
  },
  en: {
    steps: {
      tournament: 'Tournament',
      affiliation: 'Affiliation',
      category: 'Category',
    },
    stepperAria: 'Registration steps',
    intro: {
      title: 'Register for a Tournament',
      desc: 'Follow the steps below to enter your details and register for a tournament.',
    },
    step1: {
      titleLine1: 'Select your',
      titleLine2: 'tournament',
      desc: 'Select one tournament to register for. Brackets are drawn according to the event criteria of the selected tournament.',
      lockedDesc: 'This is the tournament you selected. To change it, start your registration over.',
      empty: 'No tournaments are available.',
      loadError: 'Could not load the tournament list.',
    },
    step2: {
      titleLine1: 'Enter your',
      titleLine2: 'affiliation',
      desc: 'Please enter your association, gym, and personal details accurately.',
      lockedDesc: 'These are the affiliation details you entered. To change them, start your registration over.',
    },
    step3: {
      titleLine1: 'Enter your',
      titleLine2: 'category details',
      desc: 'Date of birth, gender, grade, and height are needed to draw the brackets.',
    },
    summary: {
      tournamentTitle: 'Selected tournament',
      affiliationTitle: 'Affiliation details',
      tournamentName: 'Tournament',
      location: 'Venue',
      eventDate: 'Date',
      affiliation: 'Association',
      dojo: 'Gym',
      coachName: 'Coach',
      name: 'Name',
      phone: 'Participant phone',
      guardianPhone: 'Parent/guardian phone',
    },
    fields: {
      affiliation: 'Association (school)',
      dojo: 'Gym (team)',
      coachName: 'Coach name',
      name: 'Name',
      phone: 'Participant phone',
      guardianPhone: 'Parent/guardian phone',
      birthdate: 'Date of birth',
      gender: 'Gender',
      grade: 'Grade',
      height: 'Height (cm)',
    },
    placeholders: {
      affiliation: 'e.g. Gyeonggi Taekwondo Association',
      dojo: 'e.g. Daehwa Baekho Taekwondo',
      coachName: 'e.g. Kim Tae-kwon',
      name: 'e.g. Ha Jun-su',
      height: 'e.g. 151',
    },
    gender: {
      maleOption: 'Male',
      femaleOption: 'Female',
      maleShort: 'Male',
      femaleShort: 'Female',
    },
    buttons: {
      next: 'Next →',
      prev: '← Back',
      submit: 'Submit registration ✓',
      submitting: 'Submitting...',
      reset: 'Register again',
    },
    alerts: {
      selectTournament: 'Please select a tournament to enter.',
      requiredAffiliation: 'Association, gym, coach name, and name are required.',
      requiredPhones: 'Please enter both the participant and parent/guardian phone numbers.',
      selectGender: 'Please select a gender.',
      selectGrade: 'Please select a grade.',
      agreePrivacy: 'Please agree to the collection and use of personal information.',
      submitError: 'Registration failed. Please try again later.',
    },
    complete: {
      titleLine1: 'Your registration',
      titleLine2: 'is complete',
      subtitleLine1: 'Your registration has been received.',
      subtitleLine2: "The bracket will be announced later through the association's official channels.",
    },
    addModal: {
      title: 'Add participant',
      submit: 'Add participant',
      submitting: 'Adding...',
      error: 'Failed to add the participant. Please try again later.',
    },
    privacy: {
      label: 'Consent to collection and use of personal information',
      termsAria: 'Terms for collection and use of personal information',
    },
    grade: {
      placeholder: 'Select a grade',
      school: 'Grade {n}',
      university: 'University year {n}',
      adult: 'Adult',
    },
    validation: {
      phoneLabel: 'Phone number',
      phoneRequired: '{label} is required.',
      phoneInvalid: '{label} is not a valid phone number. e.g. 010-1234-5678',
      birthRequired: 'Please enter the date of birth.',
      birthFormat: 'Invalid date of birth. Please use the YYYY-MM-DD format (e.g. 2010-03-03).',
      birthYearRange: 'Invalid date of birth. The year must be between {min} and {max}.',
      birthMonthDay: 'Invalid date of birth. Please check the month and day.',
      birthNotExist: 'Invalid date of birth. This date does not exist.',
      birthFuture: 'Invalid date of birth. Future dates are not allowed.',
      heightRequired: 'Please enter the height.',
      heightNumber: 'Height must be a number.',
      heightMax: 'Height must be {max} cm or less.',
      heightMin: 'Height must be at least {min} cm.',
    },
  },
};

export default registration;
